import { useState } from "react"

export function UImage(props) {
    const [url, setUrl] = useState(props.src)
    const { altSrc, ...rest } = props

    function errorHandler() {
        if (url !== altSrc) {
            setUrl(altSrc)
        }
    }

    return <img {...rest} src={url} onError={errorHandler} />
}

export function UIcon(props) {
    const { size, title, name, altSrc, ...rest } = props

    return <UImage
        width={size || 24}
        height={size || 24}
        src={"/static/icon/" + name + ".png"}
        altSrc={altSrc ? '/static/icon/' + altSrc + '.png' : ''}
        alt={title || name}
        {...rest} />
}